import { render, staticRenderFns } from "./ModalConfirmacionReporteCreado.vue?vue&type=template&id=68101718&"
import script from "./ModalConfirmacionReporteCreado.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmacionReporteCreado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports